import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { logindata } from "../service/api";

const Athletelogin = () => {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [submit, setSubmit] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  },[]);
  function handlesubmit() {
    setSubmit(true);
    seterrorMessage("");
    if (!user || !pass) {
      return;
    }
    const tempData = {
      username: user,
      password: pass,
    };
    logindata(tempData).then((response) => {
      if (response.status === true) {
        const role = response.data.user_details.role;
        // App users: Student (4), Teacher (5), Worker (6), Driver (9), etc.
        // Admin / super_admin / parent (role < 4) use the web portal, not this app.
        if (role >= 4) {
          localStorage.setItem("UID", response.data.user_details.id);
          localStorage.setItem("User", response.data.user_details.name);
          localStorage.setItem("Role", role);
          localStorage.setItem("password", pass);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("academy", response.data.user_details.academy_id);
          navigate("/dashboard");
        } else {
          seterrorMessage("Invalid username or password");
        }
      } else {
        seterrorMessage(response.message);
      }
    });
  }
  return (


    <div className="auth-container d-flex justify-content-center align-items-center min-vh-100">
      <div className="circle-bg"></div>
      <div className="auth-card">
        <div className="auth-toggle">

          <div className="landinglogo">
            <img src={require("../assets/images/logo/tracking-logo.png")} alt="logo" />
          </div>
        </div>


        <form>
          <input type="text" placeholder="Enter Username" onChange={(e) => setUser(e.target.value)} value={user} />
          {submit && !user && (
            <span className="text-danger">Username is required</span>
          )}
          <input type="password" placeholder="Password" onChange={(e) => setPass(e.target.value)} value={pass} />
          {submit && !pass && (
            <span className="text-danger">Password is required</span>
          )}
          {errorMessage && <span className="text-danger">{errorMessage}</span>}
          <button
            className="btn w-100 mt-2 add-homework-submit"
            type="button"
            onClick={handlesubmit}
          >
            Login
          </button>

          <div className="text-center small text-muted mt-3">
            <p className="mb-1 attachment">
              <strong>User Name:</strong> 1st 3 letters of school code + year +
              S/T + 4-digit <span className="attachment">AMY25S6756</span>
            </p>
            <p className="mb-1 attachment">
              <strong>Password:</strong> Your DOB in DDMMYY format{" "}
              <span className="attachment">24082006</span>
            </p>
          </div>
          <div className="text-center mt-3">
            <h6>
              <span>
                Powered by{" "}
                <a style={{ color: "#007bff", textDecoration: "none" }}
                  // className="footer"
                  href="https://amytechnologies.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AMY Technologies
                </a>
              </span>
            </h6>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Athletelogin;
